import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesPersonaResponseModel } from '@/types/clarityLens/response/salesLens'

export const getSalesPersona = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string
): Promise<SalesPersonaResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/daily-sales-lens/persona`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
        item_group_name: itemGroupName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
